import { HttpEvent, HttpEventType, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { ObservableQuery } from '@apollo/client';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';

import { RequestLogout } from '../../+state';

interface ResponseBody {
  errors?: { message?: string }[];
  error?: { message?: string };
}

export function downtimeInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const store = inject(Store);
  return next(req).pipe(
    tap((event: HttpEvent<ObservableQuery.Result<unknown>>) => {
      if (event.type === HttpEventType.Response) {
        const body = event.body as ResponseBody;
        const errors: { message?: string }[] | undefined = body?.errors;
        const errorMsg: string | undefined = body?.error?.message;
        const downtimeError =
          errors?.find(e => e?.message?.includes('ERROR_APP_DOWNTIME')) ||
          (errorMsg && errorMsg.includes('ERROR_APP_DOWNTIME'))
            ? { message: 'ERROR_APP_DOWNTIME' }
            : undefined;
        if (downtimeError) {
          store.dispatch(RequestLogout({ reason: 'downtime' }));
        }
      }
    })
  );
}
